import axios from "axios";
import { respuestaMockeada } from "@/__mocks__";

const environment = process.env.NODE_ENV || "production";

const om = {
  /**
   * Realizar request genérica a la API
   * @param {Object} payload payload para el endpoint
   */
  request({ endPoint, body, mock }) {
    if (mock && environment !== "production") {
      return respuestaMockeada(endPoint, body, mock);
    }
    // Siempre retornar la promesa de axios
    return axios.post(endPoint, body);
  }
};

export default om;
